module.exports = __webpack_public_path__ + "components/guide-page/static/icon-wetsuit--shorty-07be9d4f8d0650cd585071fb397da20a.svg";